import axios from '@axios'

export const state = {
  roles: [],
  capabilities: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
  routeKeys: [
    'user',
    'document',
    'user_group',
    'topup',
    'package',
    'rate',
    'tax',
    'role',
    'capability',
    'product',
    'campaign',
    'sender',
    'smpp',
    'contact',
    'contact_group',
    'template',
    'sms_token',
    'sms_transaction_report',
    'sms_credit_report',
    'ip_token',
    'ip_transaction_report',
    'ip_credit_report',
  ],
}

export const getters = {
  allRoles: (state) => state.roles,
  allCapabilities: (state) => state.capabilities,
  allRouteKeys: (state) => state.routeKeys,
  currentPage: (state) => state.currentPage,
  totalPages: (state) => state.totalPages,
  perPage: (state) => state.perPage,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_ROLES: (state, data) => {
    state.roles = []
    if (!data.hasOwnProperty('roles')) return false
    let { roles, page, perPage, totalRecords, totalPages } = data
    state.roles = roles
    state.totalPages = totalPages
    state.currentPage = page
    state.totalRecords = totalRecords
    state.perPage = perPage
  },
  GET_CAPABILITIES: (state, data) => {
    state.roles = data
  },
  CREATE_ROLES: (state, role) => {
    state.roles.unshift(role)
  },
  DELETE_ROLE: (state, data) => {
    if (!data) return false
    state.roles = state.roles.filter((item) => item.id !== data.id)
  },
  UPDATE_ROLES: (state, data) => {
    if (!data) return false
    state.roles.forEach((element) => {
      if (element.id === data.id) {
        element.capability = data.capability
        element.name = data.name
        element.description = data.description
        element.updateDate = data.updateDate
      }
    })
  },
}

export const actions = {
  async getRole({ commit }, id) {
    return axios.get(`/roles/${id}`)
  },
  async getRoles({ commit }, params) {
    await axios
      .get(`/roles`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_ROLES', resp.data)
        } else {
          commit('GET_ROLES', {})
        }
      })
      .catch(() => {
        commit('GET_ROLES', {})
      })
  },
  async getRolesForDropDown({}, params) {
    return axios.get(`/roles`, { params: params })
  },
  async getCapability({ commit }) {
    return axios.get(`/capability`)
  },
  async deleteRole({ commit }, role) {
    return axios.delete(`/role/${role.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_ROLE', role)
      }
    })
  },
  async createRole({ commit }, role) {
    return axios.post(`/role`, role).then((resp) => {
      if (resp.status === 201) {
        commit('CREATE_ROLES', resp.data)
      }
    })
  },
  async updateRole({ commit }, role) {
    return axios.put(`/role`, role).then((resp) => {
      if (resp.status === 200) {
        commit('UPDATE_ROLES', resp.data)
      }
    })
  },
}
